import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { SellStoreStatic } from "./SellStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const SellDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SellStore: SellStoreStatic = new SellStoreStatic();
